export const REDUCER_KEY = 'users';
export const LIST_REDUCER_KEY = 'list';
export const MANAGED_USER_REDUCER_KEY = 'managed-user';
export const MANAGED_SEGMENTS_REDUCER_KEY = 'managed-segments';
export const PRODUCT_SEGMENTS_PERMISSIONS_REDUCER_KEY =
  'product-segments-permissions';
export const INVITATION_KEY = 'invitation';
